import { useRecoilValue } from "recoil"
import { IoClose } from "react-icons/io5"
import { useTranslation } from "react-i18next"
import { Box, Button, Flex, StyleProps } from "@chakra-ui/react"


import { Icon } from "../icons"
import { MODAL_Z_INDEX } from "../../../constants"
import { brandingSelector } from "../../../recoil/atoms/room"
import { useBrowserType } from "../../../hooks/useBrowserType"
import { blendWithWhiteBackground } from "../../../util"

interface OverlayModalProps {
  onCancel?: () => void
  onConfirm?: () => void
  title?: string
  subtitle?: string
  renderContent?: () => React.ReactNode
  titleStyles?: StyleProps
  closeButtonText?: string
  confirmButtonText?: string
  showActionButton?: boolean
}

const CustomOverlayModal = ({
  onCancel,
  title,
  subtitle,
  onConfirm,
  renderContent,
  titleStyles,
  closeButtonText,
  confirmButtonText,
  showActionButton = true
}: OverlayModalProps) => {
  const { t } = useTranslation()
  const roomStyles = useRecoilValue(brandingSelector)
  const { isMobile, isLandscape } = useBrowserType()

  return (
    <Box
      width="100vw"
      height="100vh"
      position="fixed"
      background="white"
      zIndex={MODAL_Z_INDEX}
      top="0"
      left="0"
      backgroundColor="rgba(255, 255, 255, 0.5)"
    >
      <Flex
        minW={isMobile && !isLandscape ? "300px" : "400px"}
        width={isMobile ? "50vw" : "500px"}
        position="absolute"
        top="50%"
        left="50%"
        padding="1rem"
        marginRight="-50%"
        transform="translate(-50%, -50%)"
        flexDirection="column"
        backgroundColor="rgba(255, 255, 255)"
        borderRadius="0.375rem"
        borderWidth="1px"
        borderStyle="solid"
        borderColor={roomStyles?.servicePanelElementBorder ?? "gray.300"}
        bg={
          blendWithWhiteBackground(
            roomStyles?.servicePanelElementModalBackground
          ) ?? "white"
        }
        color={roomStyles?.servicePanelElementPrimaryText}
      >
        {onCancel && !showActionButton && (
          <Flex
            background={
              blendWithWhiteBackground(
                roomStyles?.servicePanelElementModalBackground
              ) ?? "white"
            }
            pos="absolute"
            width="19px"
            height="19px"
            borderRadius="50%"
            right="-9px"
            top="-9px"
            alignItems="center"
            justifyContent="center"
            border="1px solid"
            borderColor={roomStyles?.servicePanelElementBorder ?? "#CBD5E0"}
            cursor={"pointer"}
            zIndex={1}
            onClick={onCancel}
          >
            <Icon
              src={IoClose}
              fontSize="0.8rem"
              marginLeft="1px"
              color={roomStyles?.servicePanelElementPrimaryText ?? "#000"}
            />
          </Flex>
        )}

        <Box
          fontSize="1.5rem"
          lineHeight="1.5"
          fontWeight="700"
          justifyContent="center"
          zIndex="10000001"
          textAlign="center"
          // marginBottom="0.5rem"
          {...titleStyles}
        >
          {title}
        </Box>
        {subtitle && (
          <Flex
            alignItems="center"
            justifyContent="center"
            marginTop="0.4rem"
            textAlign="center"
            flexDirection="column"
          >
            <Box>{subtitle}</Box>
          </Flex>
        )}

        {renderContent && renderContent()}

        {showActionButton && (
          <Flex alignItems="center" justifyContent="center" marginTop="0.4rem">
           
           {/* onCancel Button */}
           {onCancel && <Button
              onClick={onCancel}
              colorscheme="teal"
              variant="outline"
              width="unset"
              size={"sm"}
              fontSize={"sm"}
              style={{
                marginRight: "5px",
                alignSelf: "flex-end",
                width: "unset"
              }}
              bg={
                roomStyles?.secondaryAccessButtonBackgroundColor ?? "gray.100"
              }
              textColor={
                roomStyles?.secondaryAccessButtonTextColor ?? "#718096"
              }
              _hover={{
                backgroundColor:
                  roomStyles?.secondaryAccessButtonMouseoverColor ?? "#edf2f7",
                textColor:
                  roomStyles?.secondaryAccessButtonTextMouseoverColor ?? "#000"
              }}
              borderColor={
                roomStyles?.secondaryAccessButtonBorderColor ?? "#e2e8f0"
              }
              opacity={0.75}
              _focus={{}}
            >
              {closeButtonText ?? t("Ignore")}
            </Button>}

            {/* onConfirm Button */}
            {onConfirm && <Button
              colorscheme="teal"
              onClick={onConfirm}
              variant="outline"
              size={"sm"}
              fontSize={"sm"}
              style={{ alignSelf: "flex-end" }}
              _focus={{}}
              bg={
                roomStyles?.secondaryAccessButtonBackgroundColor ?? "gray.100"
              }
              textColor={
                roomStyles?.secondaryAccessButtonTextColor ?? "#718096"
              }
              _hover={{
                backgroundColor:
                  roomStyles?.secondaryAccessButtonMouseoverColor ?? "#edf2f7",
                textColor:
                  roomStyles?.secondaryAccessButtonTextMouseoverColor ?? "#000"
              }}
              borderColor={
                roomStyles?.secondaryAccessButtonBorderColor ?? "#e2e8f0"
              }
            >
              {confirmButtonText ?? t("Enter")}
            </Button>}
          </Flex>
        )}
      </Flex>
    </Box>
  )
}

export default CustomOverlayModal
